import { Validator } from '@marketto/codice-fiscale-utils';
import { ERRORS, vatNumberRegEx, zipCodeRegex } from '@/constants';
import { useTranslation } from 'react-i18next';

const ITALY_COUNTRY_CODE = 'it';

export const useValidator = (): {
  validateFiscalCode: ({
    countryCode,
    fiscalCode,
  }: {
    countryCode: string;
    fiscalCode: string | undefined;
  }) => boolean | string;
  validateVatNumber: ({
    countryCode,
    vatNumber,
  }: {
    countryCode: string;
    vatNumber: string | undefined;
  }) => boolean | string;
  validateZipCode: ({
    countryCode,
    zipCode,
  }: {
    countryCode: string;
    zipCode: string | undefined;
  }) => boolean | string;
} => {
  const { t } = useTranslation();

  const validateFiscalCode = ({
    countryCode,
    fiscalCode = '',
  }: {
    countryCode: string;
    fiscalCode: string | undefined;
  }): boolean | string => {
    if (countryCode === ITALY_COUNTRY_CODE) {
      return Validator.codiceFiscale(fiscalCode).valid || t(ERRORS.invalidFiscalCode);
    }

    return true;
  };

  const validateVatNumber = ({
    countryCode,
    vatNumber = '',
  }: {
    countryCode: string;
    vatNumber: string | undefined;
  }): boolean | string => {
    if (!(countryCode in vatNumberRegEx)) {
      return true;
    }

    return (
      vatNumberRegEx[countryCode as keyof typeof vatNumberRegEx].test(vatNumber) ||
      t(ERRORS.invalidCode)
    );
  };

  const validateZipCode = ({
    countryCode,
    zipCode = '',
  }: {
    countryCode: string;
    zipCode: string | undefined;
  }): boolean | string => {
    //always required
    if (zipCode === '') {
      return t(ERRORS.invalidCode);
    }

    if (!(countryCode in zipCodeRegex)) {
      return true;
    }

    return (
      zipCodeRegex[countryCode as keyof typeof zipCodeRegex].test(zipCode) || t(ERRORS.invalidCode)
    );
  };

  return { validateFiscalCode, validateVatNumber, validateZipCode };
};
